<div class="page-wrapper">
  <div class="wrapper">
    <app-header></app-header>
    <main [@routerAnimation]="o.isActivated ? o.activatedRoute : ''">
      <router-outlet #o="outlet"></router-outlet>
    </main>
  </div>
</div>
